var headerLinks = function () {

    var publicMethods = {};

    var dataAttribute = 'data-header-links';
    var element = document.querySelector(`[${dataAttribute}]`);

    var endpointUrl = '/api/status/check';

    publicMethods.init = function () {

        if (!element) return;

        var cultureCodeElement = document.querySelector('[data-culturecode]');
        var endpointUrlToUse = cultureCodeElement ? `${endpointUrl}?culturecode=${cultureCodeElement.getAttribute('data-culturecode')}` : endpointUrl;

        var signInActive = element.getAttribute(`${dataAttribute}-sign-in-active`) || '';
        var registerActive = element.getAttribute(`${dataAttribute}-register-active`) || '';
        var dashboardActive = element.getAttribute(`${dataAttribute}-dashboard-active`) || '';
        var registerUrl = element.getAttribute(`${dataAttribute}-register-url`) || '';
        var registerLabel = element.getAttribute(`${dataAttribute}-register-label`) || '';

        fetch(endpointUrlToUse, {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Cache-Control': 'no-cache'
            }
        }).then(function(response) {

            if (response.ok) {

                return response.json();

            } else {

                throw new Error(response);

            }

        }).then(function (response) {

            element.insertAdjacentHTML('beforeend', `
                ${response.showSignInLink ? `
                    ${response.showRegisterLink ? `<li class="${registerActive}"><a id="enterLink" href="${registerUrl}">${registerLabel}</a></li>` : ``}
                    <li class="${signInActive}"><a id="signInLink" href="${response.signInOutUrl}">${response.signInOutLinkText}</a></li>
                ` : ``}
                ${response.showSignOutLink ? `
                    <li class="${dashboardActive}"><a id="dashboardLink" href="${response.dashboardUrl}">${response.dashboardLinkText}</a></li>
                    <li><a id="signInLink" href="${response.signInOutUrl}">${response.signInOutLinkText}</a></li>
                ` : ``}
            `);

        }).catch(error => {
            throw new Error(error);
        });

    };

    return publicMethods;

}();

headerLinks.init();
